var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditedbyAuditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_888_96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5185 9.44444C24.9111 9.44444 26.7407 11.2741 26.7407 13.6667V17.8889H29.5556V13.6667C29.5556 10.2889 27.0222 7.33333 23.7852 6.77037C23.2222 3.53333 20.2667 1 16.8889 1H1.40741V34.7778H18.2963V31.963H4.22222V3.81481H16.8889C19.2815 3.81481 21.1111 5.64444 21.1111 8.03704V9.44444H22.5185ZM8.44445 10.8519V13.6667H14.0741V10.8519H8.44445ZM8.44445 19.2963H21.1111V16.4815H8.44445V19.2963Z",
    fill: "#75A481"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_888_96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1493 19.7402C26.7314 19.4255 28.3719 19.5878 29.8622 20.2051C31.3523 20.8224 32.6262 21.8678 33.5223 23.209C34.4184 24.5502 34.8964 26.1272 34.8964 27.7402C34.8963 29.9032 34.0371 31.9774 32.5077 33.5068C30.9782 35.0363 28.9041 35.8954 26.7411 35.8955C25.1281 35.8955 23.551 35.4176 22.2098 34.5215C20.8687 33.6254 19.8233 32.3515 19.2059 30.8613C18.5886 29.371 18.4264 27.7305 18.7411 26.1484C19.0558 24.5664 19.8329 23.1132 20.9735 21.9727C22.1141 20.8321 23.5673 20.055 25.1493 19.7402ZM26.7411 21.1182C25.4314 21.1182 24.1504 21.5068 23.0614 22.2344C21.9727 22.962 21.124 23.9962 20.6229 25.2061C20.1218 26.416 19.9905 27.7478 20.246 29.0322C20.5015 30.3165 21.1326 31.4959 22.0585 32.4219C22.9846 33.348 24.1646 33.9789 25.4491 34.2344C26.7336 34.4898 28.0653 34.3586 29.2753 33.8574C30.4851 33.3562 31.5194 32.5078 32.2469 31.4189C32.9745 30.3301 33.3621 29.0498 33.3622 27.7402C33.3622 25.984 32.6646 24.2995 31.4227 23.0576C30.181 21.816 28.4971 21.1182 26.7411 21.1182Z",
    fill: "#75A481",
    stroke: "#75A481",
    strokeWidth: 0.478519
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4114 24.3799C30.5067 24.3732 30.6027 24.3861 30.6927 24.418C30.7825 24.4498 30.8651 24.4995 30.9349 24.5645C31.0047 24.6295 31.0608 24.7084 31.0989 24.7959C31.1371 24.8835 31.1564 24.9787 31.1566 25.0742C31.1566 25.1696 31.1368 25.264 31.0989 25.3516C31.0625 25.4357 31.0086 25.5105 30.9427 25.5742L30.9437 25.5752L26.0198 30.8525C25.955 30.9224 25.8767 30.9783 25.7894 31.0166C25.702 31.0549 25.6074 31.0748 25.512 31.0752H25.511C25.4155 31.0749 25.3202 31.055 25.2327 31.0166C25.1455 30.9783 25.0671 30.9224 25.0023 30.8525V30.8535L22.5374 28.2139L22.5296 28.2051C22.4186 28.068 22.364 27.8937 22.3763 27.7178C22.3886 27.5418 22.467 27.3771 22.596 27.2568C22.7251 27.1366 22.8952 27.0702 23.0716 27.0703C23.2041 27.0705 23.3332 27.1078 23.4437 27.1777L23.5472 27.2578L23.555 27.2656L25.511 29.3555L29.9261 24.627H29.9271C29.9857 24.5571 30.0571 24.4992 30.138 24.457C30.2227 24.413 30.3162 24.3865 30.4114 24.3799Z",
    fill: "#75A481",
    stroke: "#75A481",
    strokeWidth: 0.337778
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_888_96"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 36.5926,
    fill: "white",
    transform: "translate(0 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_888_96"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8889,
    height: 16.8889,
    fill: "white",
    transform: "translate(18.2963 19.2959)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditedbyAuditor);
export default __webpack_public_path__ + "static/media/Audited by Auditor.402c6bf9c3a727222b4825bda476670e.svg";
export { ForwardRef as ReactComponent };